import { ChartNoAxesGantt } from 'lucide-react';

import BaseItem from './Base';
import { TYPE_OBJECT, TYPE_PROPERTY } from './types';

export default class ObjectItem extends BaseItem {
  accept = [TYPE_PROPERTY]
  icon = ChartNoAxesGantt
  title = "object"
  multipleChildren = true
  type = TYPE_OBJECT
}
